import React, { useCallback, useState } from 'react';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Grid,
    CircularProgress
} from '@material-ui/core';
import { DeleteIcon, EditIcon } from '../../../icons';
import ActionIconButton from '../../../components/atom/ActionIconButton';

import TablePager from '../../../components/atom/TablePager';
import { MODAL_TYPE, useModals } from '../../../hooks/useModal';
import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../hooks/useSwaggerClient';
import AdminHeader from '../../../components/atom/AdminHeader';

const PriceItemsListPage = () => {
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const { showModal } = useModals();
    const { notifyError, notifySuccess } = useNotify();

    const [data, loading, error, setData, reloadPriceItemNames] = useSwaggerClient(
        'priceitemnames',
        'getAllPriceItemNames',
        {
            page,
            pageSize,
            search
        }
    );

    const deletePriceItemName = useCallback(
        priceItemNameId => {
            doSwaggerCall('priceitemnames', 'deletePriceItemNameById', { priceItemNameId })
                .then(() => {
                    notifySuccess('Price item name deleted!');
                    reloadPriceItemNames();
                })
                .catch(() => {
                    notifyError('Cannot delete price item name!');
                });
        },
        [setData, data, notifyError, notifySuccess]
    );

    if (error) {
        return (
            <Grid container justifyContent="center">
                <h1>{error}</h1>
            </Grid>
        );
    }

    return (
        <Grid container className="bg-white client-table page" alignItems="center" spacing={2}>
            <AdminHeader
                title="Price items"
                search={search}
                onSearch={newSearch => {
                    setPage(0);
                    setSearch(newSearch);
                }}
                createLabel="New Price item"
                onCreate={() => {
                    showModal(MODAL_TYPE.CREATE_OR_EDIT_PRICE_ITEM_NAME, {
                        reloadPriceItemNames: reloadPriceItemNames
                    });
                }}
            />
            <Grid item container xs={12} justifyContent="center">
                {loading && data?.price_item_names.length === 0 ? (
                    <CircularProgress />
                ) : (
                    <Table style={{ backgroundColor: 'white' }} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data &&
                                data.price_item_names &&
                                data.price_item_names.map(priceItem => (
                                    <TableRow key={priceItem.id}>
                                        <TableCell>{priceItem.name}</TableCell>
                                        <TableCell style={{ width: 100 }}>
                                            <ActionIconButton
                                                title="Edit"
                                                icon={EditIcon}
                                                onClick={() => {
                                                    showModal(MODAL_TYPE.CREATE_OR_EDIT_PRICE_ITEM_NAME, {
                                                        priceItem: priceItem,
                                                        reloadPriceItemNames: reloadPriceItemNames
                                                    });
                                                }}
                                            />
                                            <ActionIconButton
                                                title="Delete"
                                                icon={DeleteIcon}
                                                onClick={() => {
                                                    showModal(MODAL_TYPE.CONFIRMATION, {
                                                        title: `Are you sure you want to remove ${priceItem?.name}?`,
                                                        content: 'This action is irreversible.',
                                                        confirm: () => deletePriceItemName(priceItem.id)
                                                    });
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                )}
                <Grid container justifyContent="flex-end">
                    <TablePager
                        total={data?.total}
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PriceItemsListPage;
